import React, { useState, useEffect } from 'react';
import { TIPOS, CATS, SUB_LABELS, EMPTY_FORM } from './constants';

const SUB_BY_TIPO = {
  venta:  ['facturada','sin_factura'],
  compra: ['nacional','importacion','tvh','courrier'],
};

const field = (label, children, err) => (
  <div>
    <label style={{fontSize:11,color:'var(--text2)',display:'block',marginBottom:4}}>{label}</label>
    {children}
    {err && <p style={{fontSize:11,color:'var(--red)',marginTop:3}}>{err}</p>}
  </div>
);

export default function MovimientoForm({ editData, onSave, onCancel }) {
  const [form, setForm]     = useState(editData || {...EMPTY_FORM});
  const [errors, setErrors] = useState({});

  useEffect(()=>{
    setForm(editData || {...EMPTY_FORM});
    setErrors({});
  },[editData]);

  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const validate = () => {
    const e={};
    if (!form.categoria) e.categoria='Selecciona una categoría';
    if (!form.monto || isNaN(parseFloat(form.monto)) || parseFloat(form.monto)<=0) e.monto='Monto inválido';
    if (!form.fecha) e.fecha='Fecha requerida';
    setErrors(e);
    return Object.keys(e).length===0;
  };

  const handleSubmit = (e)=>{
    e.preventDefault();
    if (!validate()) return;
    const monto = parseFloat(form.monto);
    const monto_iva   = form.monto_iva   ? parseFloat(form.monto_iva)   : Math.round(monto*0.19);
    const monto_total = form.monto_total ? parseFloat(form.monto_total) : Math.round(monto+monto_iva);
    onSave({...form, monto, monto_iva, monto_total});
  };

  const cats  = CATS[form.tipo] || [];
  const subs  = SUB_BY_TIPO[form.tipo] || [];
  const ins   = (k)=>({width:'100%',background:errors[k]?'rgba(239,68,68,0.05)':undefined,borderColor:errors[k]?'var(--red)':undefined});

  return (
    <div style={{background:'var(--card)',border:'1px solid var(--border2)',borderRadius:'var(--radius-lg)',padding:'1.5rem',marginBottom:20}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:18}}>
        <h3 style={{fontSize:14,fontWeight:600,display:'flex',alignItems:'center',gap:8}}>
          <i className={`ti ${editData?'ti-edit':'ti-plus'}`} style={{color:'var(--blue)'}} />
          {editData ? 'Editar movimiento' : 'Nuevo movimiento'}
        </h3>
        <button onClick={onCancel} className="icon-btn" title="Cerrar"><i className="ti ti-x" /></button>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Tipo */}
        <div style={{marginBottom:14}}>
          <label style={{fontSize:11,color:'var(--text2)',display:'block',marginBottom:7}}>Tipo *</label>
          <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
            {Object.entries(TIPOS).map(([k,v])=>(
              <button key={k} type="button"
                onClick={()=>{set('tipo',k);set('categoria','');set('subTipo',SUB_BY_TIPO[k]?.[0]||'');}}
                style={{padding:'5px 11px',fontSize:12,display:'flex',alignItems:'center',gap:5,
                  background:form.tipo===k?v.bg:'transparent',
                  color:form.tipo===k?v.color:'var(--text2)',
                  borderColor:form.tipo===k?v.border:'var(--border)',
                  fontWeight:form.tipo===k?600:400}}>
                <i className={`ti ${v.icon}`} />{v.label}
              </button>
            ))}
          </div>
        </div>

        {/* SubTipo */}
        {subs.length>0 && (
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11,color:'var(--text2)',display:'block',marginBottom:7}}>Subtipo</label>
            <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
              {subs.map(s=>(
                <button key={s} type="button" onClick={()=>set('subTipo',s)}
                  style={{padding:'4px 10px',fontSize:11,
                    background:form.subTipo===s?'var(--blue-bg)':'transparent',
                    color:form.subTipo===s?'var(--blue)':'var(--text2)',
                    borderColor:form.subTipo===s?'var(--blue-border)':'var(--border)',
                    fontWeight:form.subTipo===s?600:400}}>
                  {SUB_LABELS[s]||s}
                </button>
              ))}
            </div>
          </div>
        )}

        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(190px,1fr))',gap:12}}>
          {field('Categoría *',
            <select value={form.categoria} onChange={e=>set('categoria',e.target.value)} style={ins('categoria')}>
              <option value="">Seleccionar...</option>
              {cats.map(c=><option key={c} value={c}>{c}</option>)}
            </select>, errors.categoria)}

          {field('Monto Neto (CLP) *',
            <input type="number" min="1" placeholder="0" value={form.monto}
              onChange={e=>set('monto',e.target.value)} style={ins('monto')} />, errors.monto)}

          {field('IVA (CLP)',
            <input type="number" min="0" placeholder="Se calcula 19% automático" value={form.monto_iva}
              onChange={e=>set('monto_iva',e.target.value)} />)}

          {field('Total (IVA inc.)',
            <input type="number" min="0" placeholder="Se calcula automático" value={form.monto_total}
              onChange={e=>set('monto_total',e.target.value)} />)}

          {field('Fecha *',
            <input type="date" value={form.fecha}
              onChange={e=>set('fecha',e.target.value)} style={ins('fecha')} />, errors.fecha)}

          {field('N° Factura / Folio',
            <input type="text" placeholder="Ej: 1234 / S/F" value={form.nFactura}
              onChange={e=>set('nFactura',e.target.value)} />)}

          {field('RUT Contraparte',
            <input type="text" placeholder="Ej: 77.000.332-6" value={form.rutContraparte}
              onChange={e=>set('rutContraparte',e.target.value)} />)}

          {field('Razón Social / Proveedor',
            <input type="text" placeholder="Nombre empresa" value={form.razonSocial}
              onChange={e=>set('razonSocial',e.target.value)} />)}

          {field('P/N (Parte)',
            <input type="text" placeholder="Código de parte" value={form.pn}
              onChange={e=>set('pn',e.target.value)} />)}

          {field('Descripción',
            <input type="text" placeholder="Detalle del movimiento" value={form.descripcion}
              onChange={e=>set('descripcion',e.target.value)} />)}

          <div style={{gridColumn:'1/-1'}}>
            {field('Notas / Observaciones',
              <textarea placeholder="RUT, forma de pago, observaciones..." value={form.notas}
                onChange={e=>set('notas',e.target.value)} />)}
          </div>
        </div>

        <div style={{display:'flex',gap:8,marginTop:16}}>
          <button type="submit" className="primary">
            <i className={`ti ${editData?'ti-check':'ti-plus'}`} />
            {editData ? 'Guardar cambios' : 'Registrar movimiento'}
          </button>
          <button type="button" onClick={onCancel}>Cancelar</button>
        </div>
      </form>
    </div>
  );
}
